import React from 'react';
import { bool, node } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';

import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import * as validators from '../../util/validators';
import {
  Form,
  PrimaryButton,
  Button,
  FieldTextInput,
  IconClose,
  SecondaryButton,
} from '../../components';

import css from './AddFavorites.module.css';

const AddFavoritesFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        form,
        handleSubmit,
        inProgress,
        invalid,
        intl,
        values,
        onCloseModal,
      } = fieldRenderProps;

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = invalid || submitInProgress || !values?.title;

      const closeModal = () => {
        onCloseModal(), form.change('title', null);
      };

      return (
        <Form className={classes} onSubmit={handleSubmit}>

          <div className={css.listPopupButtons}>
            <SecondaryButton
              className={classNames(css.btn, css.btnWhite)}
              onClick={closeModal}
              inProgress={submitInProgress}
            >
              <FormattedMessage id="FavoritesPage.cancel" />
            </SecondaryButton>

            <Button
              className={classNames(css.btn, css.btnDefault)}
              type="submit"
              inProgress={submitInProgress}
            >
              <FormattedMessage id="FavoritesPage.save" />
            </Button>
          </div>
        </Form>
      );
    }}
  />
);

AddFavoritesFormComponent.defaultProps = { inProgress: false };

AddFavoritesFormComponent.propTypes = {
  inProgress: bool,
  // from injectIntl
  intl: intlShape.isRequired,
};

const AddFavoritesForm = compose(injectIntl)(AddFavoritesFormComponent);
AddFavoritesForm.displayName = 'AddFavoritesForm';

export default AddFavoritesForm;
